import { ExceptionError } from '../model/error-track.model';
import { ERROR_TYPE } from '@cv-invision/core';
export class LogErrorException {
	static readonly type = '[ErrorTrack] Log Error Exception';
	constructor(public newExceptionError: ExceptionError) {}
}

export class ClearErrorException {
	static readonly type = '[ErrorTrack] Clear Error Exception';
	constructor(public errorTypeToClear: ERROR_TYPE[]) {}
}
